import { Injectable } from "@angular/core";
import { filter, map, share, tap } from "rxjs/operators";
import { Observable, ReplaySubject } from "rxjs";
import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "../auth/service/auth.service";

type StringifiedBoolean = "true" | "false";
// Welcome wizard will be re-implemented in the future: https://jira.nfon.net/browse/NFON-757
export type UserHelpModes = {
  welcomeWizard?: StringifiedBoolean;
  helpMode: StringifiedBoolean;
};

@Injectable({
  providedIn: "root",
})
export class UserHelpModesService {
  private readonly helpModesUrl: string = `${environment.API_URL}/settings/app`;
  private userHelpModesSource: ReplaySubject<UserHelpModes> = new ReplaySubject(
    1,
  );

  public isHelpModeActive$: Observable<boolean>;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {
    this.isHelpModeActive$ = this.userHelpModesSource.pipe(
      filter((userHelpModes: UserHelpModes) => !!userHelpModes),
      map((userHelpModes: UserHelpModes) => userHelpModes?.helpMode === "true"),
    );
    this.authService.userInfo$.subscribe(() => {
      this.getUserHelpModes();
    });
  }

  public getUserHelpModes(): Promise<UserHelpModes | undefined> {
    return this.http
      .get<UserHelpModes>(this.helpModesUrl)
      .pipe(
        tap((userHelpModes: UserHelpModes) => {
          this.userHelpModesSource.next(userHelpModes);
        }),
        share(),
      )
      .toPromise();
  }

  public setHelpMode(isHelpModeActive: boolean): Promise<{} | undefined> {
    const helpMode: UserHelpModes = {
      helpMode: isHelpModeActive.toString() as StringifiedBoolean,
    };

    return this.http
      .put(this.helpModesUrl, helpMode)
      .pipe(
        tap(() => {
          this.userHelpModesSource.next(helpMode);
        }),
        share(),
      )
      .toPromise();
  }

  public clearUserHelpModesSettings(): void {
    this.userHelpModesSource.next({} as UserHelpModes);
  }
}
